const parseFormattedAmount = (amount, details) => {
  if (typeof amount === 'number') return amount;

  const _amount = amount.replace(new RegExp(details.delimiter, 'g'), '');
  return parseFloat(_amount.replace(details.separator, '.'));
};

export default parseFormattedAmount;
